
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../../context/SnackbarProvider/SnackbarProvider'
import { useSyncQueryCache } from '../organizations_table/useSyncQueryCache'

const extractS3Key = (url: string) => {
  try {
    const parts = new URL(url)
    return decodeURIComponent(parts.pathname.slice(1))
  } catch {
    console.warn('❌ Could not extract key from URL:', url)
    return null
  }
}
const deleteCommentAndAttachments = async ({
  note,
  _queryKeysToInvalidate = [],
}: {
  note: any
  _queryKeysToInvalidate?: (string | unknown[])[]
}) => {
  if (!note) {
    console.error('No note provided for deletion.')
    return
  }
  try {
    // 🧹 Step 1: Delete attachments + thumbnails from S3
    const attachmentFiles = note.attachments || []
    const allKeysToDelete = attachmentFiles
      .flatMap(file => [extractS3Key(file.url), extractS3Key(file.thumbnailLink)])
      .filter(Boolean)

    if (allKeysToDelete.length > 0) {
      await axios.post(`${baseUrl}/aws/s3/attachments/delete-multiple`, {
        keys: allKeysToDelete,
      })
      console.log('🗑️ Deleted from S3:', allKeysToDelete)
    }

    // 🧹 Step 2: Delete the comment itself
    await axios.post(`${baseUrl}/aws/comments/delete-comment`, {
      PK: note.PK,
      SK: note.SK,
      attachments: note.attachments || [],
    })
    console.log('🗑️ Deleted comment:', note.comment_uuid)

    // 🧹 Step 3: Invalidate any React Query keys

    // showSnackbar('Comment deleted successfully', 'success')
  } catch (error) {
    console.error('❌ Failed to delete comment or attachments:', error)
    // showSnackbar('Failed to delete comment', 'error')
  }
}
export const useDeleteCommentAndAttachments = () => {
  const { showSnackbar } = useSnackbarContext()
  const queryClient = useQueryClient()
  const {
    syncCommentsTableAndQueryCacheAfterDeletion: _syncCommentsTableAndQueryCacheAfterDeletion,
  } = useSyncQueryCache()

  return useMutation<any, Error, any>({
    mutationFn: deleteCommentAndAttachments,

    onSuccess: (data, variables) => {
      // console.log('variables', variables)
      console.log(
        '[useDeleteCommentsAndAttachments] Comment deleted Successfully:',
        'data',
        data,
        'variables',
        variables
      )
      // queryClient.invalidateQueries({ queryKey: ['comments', ] })
      showSnackbar('Comment deleted successfully', 'success')
    },

    onError: (error, _newComment, context: any) => {
      if (context?.previousComments) {
        queryClient.setQueryData(['comments'], context.previousComments)
      }
      console.error('[useDeleteCommentsAndAttachments] Mutation Error:', error)
      showSnackbar((error as any).response?.data?.message || error.message, 'error')
    },

    onSettled: () => {
      // queryClient.invalidateQueries({ queryKey: ['comments'] })
    },
  })
}
